// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-textformat-italic"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 3H12.5M10 3H7.5M10 3V21M10 21H7.5M10 21H12.5M6 7.5H3V16.5H6M21 12.5V16.5H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.25 5.75L18.7697 6.98028L20 7.5L18.7697 8.01972L18.25 9.25L17.7303 8.01972L16.5 7.5L17.7303 6.98028L18.25 5.75Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiTextformatItalicIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-textformat-italic',
    ref,
    icon: element,
  },
));

AiTextformatItalicIcon.displayName = 'AiTextformatItalicIcon';

export default AiTextformatItalicIcon;
